import service from '@/base/service'
import qs from 'qs'

const baseURL = process.env.VUE_APP_BASE_API_AI

const request = (data) => {
  return service({ ...data, ...{ baseURL } })
}
const requestLocal = (data) => {
  return service({ ...data, ...{ baseURL: '/local' } })
}
const requestLocal2 = (data) => {
  return service({ ...data, ...{ baseURL: '/apiCX' } })
}

//推荐列表  由于临时改版，后端暂时先采用换一换 - HID
export function recommendList(data) {
  return request({
    //url: 'vv5/recommend/change',
    url: 'vv5/recommend/relations',  // 应后端要求 更改
    method: 'get',
    params: data
  })
}

//  企业评价
export function enterpriseEvaluate(data) {
  return request({
    url: '/company/enterpriseEvaluate',
    method: 'post',
    data
  })
}


// 企业评价-规模
export function evaluateScale(data) {
  return request({
    url: '/company/evaluate/scale',
    method: 'get',
    params: data
  })
}

// 企业评价-稳定
export function evaluateStability(data) {
  return request({
    url: '/company/evaluate/stability',
    method: 'get',
    params: data
  })
}

// 企业评价-创新
export function evaluateInnovation(data) {
  return request({
    url: '/company/evaluate/innovation',
    method: 'get',
    params: data
  })
}

// 企业评价-成长
export function evaluateGrowth(data) {
  return request({
    url: '/company/evaluate/growth',
    method: 'get',
    params: data
  })
}

// 企业评价-财务
export function evaluateFinance(data) {
  return request({
    url: '/company/evaluate/finance',
    method: 'get',
    params: data
  })
}

// 企业评价-履约
export function evaluateCredit(data) {
  return request({
    url: '/company/evaluate/credit',
    method: 'get',
    params: data
  })
}

export function recommendListNew(data) {
  return request({
    url: 'vv5/recommend/relations',
    method: 'get',
    params: data
  })
}


//  查询深度挖掘列表
export function delveList(data) {
  return request({
    url: 'delveRecord/delveList',
    method: 'get',
    params: data
  })
}

//  深度挖掘
export function deepKeyword(data) {
  return request({
    url: 'delveRecord/delve',
    method: 'post',
    data
  })
}

//  解锁列表
export function unlockList(data) {
  return request({
    url: 'clue/unlockList',
    method: 'get',
    params: data
  })
}


// 解锁联系方式 - HID
export function contactList(data) {
  return request({
    url: 'vv5/contact/contactsNumPC',
    method: 'get',
    params: data
  })
}

// 导出联系方式
export function contactExport(data) {
  return request({
    url: 'excelExport/contactExport',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 批量获取联系方式
// export function contactsNumBatchV2 (data) {
//   return request({
//     url: 'contact/contactsNumBatchV2',
//     method: 'post',
//     data: data
//   })
// }
// 批量获取联系方式 - HID
export function contactsNumBatchV2(data) {
  return request({
    url: 'vv5/contact/contactsNumBatch',
    method: 'post',
    data: data
  })
}

//  企业资讯
export function getNews(data) {
  return request({
    url: 'clue/news',
    method: 'POST',
    data
  })
}

//  添加成交客户
// export function clientAdd (data) {
//   return request({
//     url: 'transaction/add',
//     method: 'POST',
//     data
//   })
// }
// 添加成交客户 - HID
export function clientAdd(data) {
  return request({
    url: 'vv5/transaction/add',
    method: 'POST',
    data
  })
}

//  删除成交客户
export function clientDelete(data) {
  return request({
    url: 'transaction/delete',
    method: 'get',
    params: data
  })
}

// //  查询成交客户
// export function clientList (data) {
//   return request({
//     url: 'transaction/list',
//     method: 'get',
//     params: data
//   })
// }
//  查询成交客户
export function clientList(data) {
  return request({
    url: '/vv5/transaction/list',
    method: 'get',
    params: data
  })
}


export function associationSubmit(data) {
  return request({
    url: '/transaction/association/saveOrUpdate',
    method: 'POST',
    data
  })
}

// 企业图谱
export function getEnterpriseGraph(data) {
  return request({
    url: '/company/enterpriseGraph',
    method: 'POST',
    data
  })
}



// 关注客户
// export function batchStar (data) {
//   return request({
//     url: 'clue/batchStar',
//     method: 'POST',
//     data
//   })
// }
// 关注客户 - HID
export function batchStar(data) {
  return request({
    url: 'vv5/clue/batchStar',
    method: 'POST',
    data
  })
}

// 关不感兴趣
export function uninterested(data) {
  return request({
    url: 'uninterested/add',
    method: 'POST',
    data
  })
}

// 新增企业
export function newCompany(data) {
  return request({
    url: 'newCompany/pageV3',
    method: 'POST',
    data
  })
}
//获取新注册企业列表
export function getNewCompany(data) {
  return request({
    url: 'clue/searchByCondition',
    method: 'POST',
    data
  })
}

// 推荐企业提交
// export function submit () {
//   return request({
//     url: 'transaction/submit',
//     method: 'get'
//   })
// }
// 推荐企业提交 - HID
export function submit() {
  return request({
    url: 'vv5/transaction/submit',
    method: 'get'
  })
}

// 号码反馈
export function feedback(data) {
  return request({
    url: '/vv5/contact/reportContact',
    method: 'POST',
    data
  })
}


// 号码反馈回显
export function feedbackDetail(data) {
  return request({
    url: '/vv5/contact/reportContactDetail',
    method: 'POST',
    data
  })
}


// 公司名称模糊查询 - HID
export function getByName(data) {
  return request({
    url: 'vv5/company/selectByName',
    method: 'get',
    params: data
  })
}

// export function contactSubmit (data) {
//   return request({
//     url: 'contact/contactSubmitV2',
//     method: 'post',
//     data
//   })
// }
//领取线索 - HID
export function contactSubmit(data) {
  return request({
    url: 'vv5/contact/contactSubmit',
    method: 'post',
    data
  })
}


// 公司信息数量统计 - HID
export function companyCategoryCountV2(data) {
  return request({
    url: 'vv5/companyDetail/companyCategoryCount',
    method: 'GET',
    params: data
  })
}

// 公司信息数量统计
// export function companyBasicCountV2 (data) {
//   return request({
//     url: 'companyDetail/companyBasicCountV3',
//     method: 'GET',
//     params: data
//   })
// }
//公司信息数量统计 - HID
export function companyBasicCountV2(data) {
  return request({
    url: 'vv5/companyDetail/companyBasicCount',
    method: 'GET',
    params: data
  })
}

//高级搜索埋点
export function companyBuried(data) {
  return request({
    url: 'advancedPoint/addPoint',
    method: 'post',
    data
  })
}
// 公司信息批量
// export function companyDetailBatchV2 (data) {
//   return request({
//     url: 'companyDetail/companyDetailBatchV2',
//     method: 'post',
//     data
//   })
// }

//公司信息批量 - HID
export function companyDetailBatchV2(data) {
  return request({
    url: 'vv5/companyDetail/companyDetailBatch',
    method: 'post',
    data
  })
}

// 公司信息批量1      以后详情渐渐要转移到这个模块 - HID
export function getByPageBatchV2(data) {
  return request({
    url: 'vv5/companyDetail/getByPageBatch',
    method: 'post',
    data
  })
}

// 分项评分-包含同行业对比
export function getStisCategory(data) {
  return request({
    url: '/company/stis/category',
    method: 'GET',
    params: data
  })
}


// 获取HBase数据单模块接口V2
// export function getByPageV2 (data) {
//   return request({
//     url: 'companyDetail/module',
//     method: 'post',
//     data
//   })
// }
// 获取HBase数据单模块接口V2 - HID
export function getByPageV2(data) {
  return request({
    url: 'vv5/companyDetail/module',
    method: 'post',
    data
  })
}

// 抽奖2
export function ad2(data) {
  return request({
    url: 'advertising/ad2',
    method: 'GET',
    params: data
  })
}

// 抽奖1
export function ad1(data) {
  return request({
    url: 'advertising/ad1',
    method: 'GET',
    params: data
  })
}

// 查看是否有领取礼包的机会
export function opportunityExists(data) {
  return request({
    url: 'advertising/opportunityExists',
    method: 'GET',
    params: data
  })
}

// 查看联系方式次数
// export function contactCount (data) {
//   return request({
//     url: 'contact/contactCountV2',
//     method: 'post',
//     data
//   })
// }
// 查看联系方式次数 - HID
export function contactCount(data) {
  return request({
    url: 'vv5/contact/contactCount',
    method: 'post',
    data
  })
}


// 企业简介 - HID
export function companyBrief(data) {
  return request({
    url: 'vv5/companyDetail/companyBrief',
    method: 'get',
    params: data
  })
}

// 相似企业
export function similarCompanyList(data) {
  return request({
    url: 'companyDetail/similarCompanyList ',
    method: 'post',
    data
  })
}

// 臻信通
// export function cxt(data) {
//   return request({
//     // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//     url: '/clue/cxt',
//     method: 'get',
//     params: data
//   })
// }

//  高级搜索 -- 全部分类
export function highKeywordList() {
  return request({
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    url: '/advancedSearch/keywordList',
    method: 'get'
  })
}

//  高级搜索 --  高级筛选模板列表
export function getTemplateList(data) {
  return request({
    url: '/advancedSearch/templateList',
    method: 'post',
    data
  })
}

//  高级搜索 --  高级筛选  查询分类
export function selectOptions(data) {
  return request({
    url: '/advancedSearch/selectOptions',
    method: 'post',
    data
  })
}

//  高级搜索 --  高级筛选  保存
export function saveOrUpdateTemplate(data) {
  return request({
    url: '/advancedSearch/saveOrUpdateTemplate',
    method: 'post',
    data
  })
}
//  高级搜索 --  高级筛选  删除
export function deleteTemplate(data) {
  return request({
    url: '/advancedSearch/deleteTemplate',
    method: 'post',
    data
  })
}

//  高级搜索 --  高级筛选  搜索
// export function advancedSearch (data) {
//   return request({
//     url: '/advancedSearch/advancedSearch',
//     method: 'post',
//     data
//   })
// }
//  高级搜索 --  高级筛选  搜索 - HID
export function advancedSearch(data) {
  return request({
    url: '/vv5/advancedSearch/advancedSearch',
    method: 'post',
    data
  })
}

// 招标查询 -  列表
// export function queryTenderList (data) {
//   return request({
//     url: 'companyInfo/queryTenderList',
//     method: 'post',
//     data
//   })
// }
// 招标查询 - 列表 - HID  （调取此接口的板块已隐藏）
export function queryTenderList(data) {
  return request({
    url: 'vv5/companyInfo/queryTenderList',
    method: 'post',
    data
  })
}

// 招标查询 - 连锁记忆
export function queryTenderBySearch(data) {
  return request({
    url: 'companyInfo/queryTenderBySearch',
    method: 'post',
    data
  })
}

// 招标查询 -  公司信息 查询
// export function searchByName (data) {
//   return request({
//     url: 'clue/searchByName',
//     method: 'get',
//     params: data
//   })
// }
// 招标查询 -  公司信息 查询 - HID
export function searchByName(data) {
  return request({
    url: 'vv5/clue/searchByName',
    method: 'get',
    params: data
  })
}

// 添加(编辑)站点
export function saveOrUpdateSite(data) {
  return request({
    url: 'siteUser/saveOrUpdateTemplate',
    method: 'post',
    data: data
  })
}

// 站点列表(不分页)
export function siteSelectList(data) {
  return request({
    url: 'siteUser/selectList',
    method: 'post',
    data: data
  })
}

// 站点列表(分页)
export function siteSelectListPage(data) {
  return request({
    url: 'siteUser/selectListPage',
    method: 'post',
    data: data
  })
}

// 站点删除
export function deleteSiteId(data) {
  return request({
    url: 'siteUser/deleteById',
    method: 'post',
    data: data
  })
}
//  公司信息 查询
export function selectOptionsList(data) {
  return request({
    url: 'clue/selectOptionsList',
    method: 'get',
    params: data
  })
}

// 检查是否安装成功
export function checkMainUrl(data) {
  return request({
    url: 'siteUser/checkMainUrl',
    method: 'post',
    data: data
  })
}

// 匿名公司 搜索
export function queryAnonymousCompany(data) {
  return request({
    url: 'siteUser/queryAnonymousCompany',
    method: 'post',
    data: data
  })
}

// 获取匿名访客js安装代码
export function queryAnonymousJS(data) {
  return request({
    url: 'siteUser/queryAnonymousJS',
    method: 'post',
    data: data
  })
}

// 获取crm权限
export function hasCrmEquity(data) {
  return request({
    url: 'clue/hasCrmEquity',
    method: 'get',
    params: data
  })
}

// 公司访问埋点
// export function visitCompany (data) {
//   return request({
//     url: '/track/visitCompany',
//     method: 'post',
//     data
//   })
// }
// 公司访问埋点 - HID
export function visitCompany(data) {
  return request({
    url: '/vv5/track/visitCompany',
    method: 'post',
    data
  })
}

// 年报详情
export function yearModuleDetail(data) {
  return request({
    url: 'companyDetail/moduleDetail',
    method: 'post',
    data
  })
}

// 高级搜索 批量解锁前500
export function advancedSearchUnlock(data) {
  return request({
    url: '/vv6/advancedSearch/advancedSearchUnlock',
    method: 'post',
    data
  })
}

// 解锁列表复制联系方式增加埋点
export function copyContact(data) {
  return request({
    url: 'track/copyContact',
    method: 'post',
    data
  })
}

// 首页商机订阅窗top4
export function subscribeTop(data) {
  return request({
    url: '/subscription/top',
    method: 'get',
    params: data
  })
}

// 企业列表单个接口完成后、批量解锁完成后
export function unlockContacts(data) {
  return request({
    url: 'contact/hids/contacts',
    method: 'post',
    data
  })
}

// 批量解锁提示
export function unlockBatchTip(data) {
  return request({
    url: 'log/unlockBatch',
    method: 'get',
    params: data
  })
}

//埋点接口
export function testPoint(data) {
  return request({
    url: '/third/test/point',
    method: 'post',
    data
  })
}

// 主营产品词
export function mainProductWord(data) {
  return request({
    url: 'vv5/companyDetail/mainProduct',
    method: 'get',
    params: data
  })
}

// 删除解锁列表标签
export function delTag(data) {
  return request({
    url: '/contact/del',
    method: 'get',
    params: data
  })
}


// 招投标
export function tenderPage(data) {
  return request({
    url: '/tender/page',
    method: 'post',
    data
  })
}
// 新闻
export function newsCluePage(data) {
  return request({
    url: '/clue/page',
    method: 'post',
    data
  })
}


